/* ORION: the refreshed mattress page rests what is not on screen. Every block marked data-orion-live (the right
   column, the reviews, the try-out map) gets .is-resting while it is out of view, and its looping
   CSS motion pauses (assets/orion-mattress-refresh.css) until it comes back, so the page spends nothing on motion
   nobody sees. The scripted motion (the Earth, the shooting stars) watches visibility on its own. */
(() => {
  const blocks = document.querySelectorAll('[data-orion-live]');
  if (!blocks.length || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => entry.target.classList.toggle('is-resting', !entry.isIntersecting));
  }, { rootMargin: '120px 0px' });
  blocks.forEach((block) => observer.observe(block));
})();
